import React,{useState, useEffect} from 'react';
import netflix_logo1 from './assets/netflix_logo1.png';
import netflix_avatar from './assets/netflix_avatar.png';
import './Nav.css';


function Nav(){
	const [show, handleShow]=useState(false);
	useEffect(()=>{
		window.addEventListener("scroll", () =>{
          if( window.scrollY > 100) {
          	handleShow(true);

          } else handleShow(false);
		});

            return() => {
            	window.removeEventListener("scroll");
            };
	},[]);
	return(
     <div className={`nav ${show && "nav_black"}`}>
   <img
   className="nav_logo"
   src={netflix_logo1}
   alt="Netflix_logo"

   />
   <img
   className="nav_avatar"
   src={netflix_avatar}
   alt="Netflix_logo"

   />
     </div>

		)
}

export default Nav;